// import firebase from '@/utils/firebase';
import jwt_decode from 'jwt-decode';
// import LogRocket from 'logrocket';

import UserService from '@/services/userService';
import SessionHelper, { STORAGE_BLOCKED_ERROR } from '@/utils/session';
import {  getAuth, signInWithPopup, GoogleAuthProvider, signOut } from "firebase/auth";

const FIREBASE_ERROR_MESSAGES = {
    'auth/popup-blocked': 'Seu navegador bloqueou a janela do Google. Libere os pop-ups para este site e tente novamente.',
    'auth/popup-closed-by-user': 'A janela do Google foi fechada antes de concluir o login.',
    'auth/cancelled-popup-request': 'A janela do Google foi fechada antes de concluir o login.',
    'auth/network-request-failed': 'Não foi possível conectar ao Google. Verifique sua internet e tente novamente.',
    'auth/unauthorized-domain': 'Este endereço não está autorizado para login. Avise o administrador do bolão.',
    'auth/operation-not-supported-in-this-environment': 'Seu navegador não suporta o login do Google. Abra o site no Chrome ou Safari.',
};

function firebaseErrorMessage(error) {
    return FIREBASE_ERROR_MESSAGES[error.code]
        || 'Não foi possível entrar com o Google. Tente novamente.';
}

function apiErrorMessage(error) {
    if (error.response === undefined) {
        return 'Não foi possível conectar ao servidor. Verifique sua internet e tente novamente.';
    }

    const { status, data } = error.response;

    if (data !== undefined && data !== null && data.message) {
        return data.message;
    }

    if (status === 401 || status === 403) {
        return 'Seu acesso ainda não foi liberado. Fale com o administrador do bolão.';
    }

    if (status >= 500) {
        return 'O servidor não respondeu corretamente. Tente novamente em alguns instantes.';
    }

    return 'Não foi possível concluir o login. Tente novamente.';
}

const state = {
    userProfile: {},
    loggedIn: false,
};

const getters = {
    userProfile: ({ userProfile}) => userProfile,
    loggedIn: ({ loggedIn }) => loggedIn,
};

const mutations = {
    USER_DETAILS(state, userProfile) {
  
        if (state.userProfile.id !== undefined) return;

        state.loggedIn = true;
        state.userProfile = {
          name: userProfile.name,
          email: userProfile.email,
          picture: userProfile.photoURL,
          id: userProfile.id,
          rules: userProfile.rules,
        };
    },
    LOGOUT(state) {
        state.loggedIn = false;
        state.userProfile = {};
    }
};

const actions = {
    // Lança Error com mensagem pronta para exibição. Quem chama é responsável
    // por mostrar o erro — nunca engolir, senão a tela de login trava sem feedback.
    async login(store) {
        // Garante que não sobrou credencial antiga na requisição de login.
        SessionHelper.clear();

        const provider = new GoogleAuthProvider();
        const auth = getAuth();

        let result;
        try {
            result = await signInWithPopup(auth, provider);
        } catch (error) {
            const credential = GoogleAuthProvider.credentialFromError(error);
            console.log(error, credential);
            throw new Error(firebaseErrorMessage(error));
        }

        const userInfo = result.user;
        let user = {
            name: userInfo.displayName,
            email: userInfo.email,
            photoURL: userInfo.photoURL
        }

        let responseLogin;
        try {
            responseLogin = await UserService.login(user);
        } catch (error) {
            console.log(error);
            await store.dispatch('cleanupFailedLogin');
            // setToken lança Error próprio quando o localStorage está bloqueado.
            throw error.name === STORAGE_BLOCKED_ERROR
                ? error
                : new Error(apiErrorMessage(error));
        }

        if (responseLogin === undefined || responseLogin.token === undefined) {
            await store.dispatch('cleanupFailedLogin');
            throw new Error(responseLogin && responseLogin.message
                ? responseLogin.message
                : 'Seu acesso ainda não foi liberado. Fale com o administrador do bolão.');
        }

        let payload;
        try {
            payload = jwt_decode(responseLogin.token);
        } catch (error) {
            console.log(error);
            await store.dispatch('cleanupFailedLogin');
            throw new Error('Recebemos uma resposta inválida do servidor. Tente novamente.');
        }

        user.id = payload._id;
        user.name = payload.name;
        user.rules = payload.rules;
        store.commit(`USER_DETAILS`, user);

            // LogRocket.identify(user.id, {
        //         name: user.name,
        //         email: user.email,
        //       });
    },

    // Login do Google deu certo mas o backend não: derruba a sessão do Firebase
    // para não ficar "autenticado" sem JWT.
    async cleanupFailedLogin(store) {
        SessionHelper.clear();
        store.commit(`LOGOUT`);
        try {
            await signOut(getAuth());
        } catch (error) {
            console.log(error);
        }
    },

    async logout(store){
        // Limpeza síncrona primeiro: o signOut é lento e não pode atrasar
        // a remoção do token nem sobrescrever um login feito logo em seguida.
        SessionHelper.clear();
        store.commit(`LOGOUT`);

        try {
            await signOut(getAuth());
        } catch(error) {
            console.log(error);
        }
    }
}

export default {
    namespaced: true,
    state,
    getters,
    mutations,
    actions
}